import { Component, Input, OnInit } from '@angular/core';
import { PopoverController, NavController } from '@ionic/angular';
import { TaskModel } from 'app/models/dms/tasksSearchResult.model';
import { UserService } from 'app/services/user.service';
import { SecurityRight } from 'app/utility/enums';

@Component({
    template: `
        <ion-list lines="none" class="ion-no-margin" inset="false" mode="md">
            <ion-item (click)="performAction('snoozeReminder')">
                <ion-label>Snooze reminder</ion-label>
            </ion-item>
            <ion-item (click)="performAction('dismiss')">
                <ion-label>Dismiss reminder</ion-label>
            </ion-item>
            <ion-item-divider style="min-height: 0px"></ion-item-divider>
            <ion-item (click)="performAction('view')">
				<ion-label>View task</ion-label>
			</ion-item>
            <ion-item (click)="performAction('edit')">
                <ion-label>Edit task</ion-label>
            </ion-item>
            <ion-item (click)="performAction('doTaskWithOutPrompts')">
                <ion-label>Do task</ion-label>
            </ion-item>         
                
        </ion-list>
        `,
    standalone: false
})

export class ReminderListItemPopover implements OnInit
{

    @Input() reminderTask: TaskModel;

    constructor(
        private popoverCtrl: PopoverController,
        private userService: UserService
    ) { }

    ngOnInit(): void
    {

    }

    async onDismiss()
    {
        try
        {
            await this.popoverCtrl.dismiss();
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    async performAction(action: string)
    {
        try
        {
            await this.popoverCtrl.dismiss(action);
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    public hasPermission(action: string): boolean
    {
        switch (action)
        {
            case "edit-tasks":
                return this.userService.hasUserRight(SecurityRight.ToolsTasksFunctionsEdit);
                break;
            default:
                return true;
                break;
        }
    }
}